import React, { Component, useContext, useEffect, useState } from "react";
/// Menu
import Metismenu from "metismenujs";
/// Scroll
import { IoTicketOutline } from "react-icons/io5";
import PerfectScrollbar from "react-perfect-scrollbar";
/// Link
import { Link, NavLink } from "react-router-dom";

import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { Can } from "../../../context/Can";
import { ThemeContext } from "../../../context/ThemeContext";
import medal from "../../../images/medal.png";

import { useServicesQuery } from "../../../api/user/user.hooks";
import { getUserPermissions, getUserRole } from "../../../APIS";
import LogoutPage from "./Logout";
import {
  FaShieldAlt,
  FaClipboardCheck,
  FaGlobe,
  FaBuilding,
  FaTicketAlt,
  FaShip,
  FaBinoculars,
  FaTrain,
  FaUsers,
  FaTachometerAlt,
  FaWindowMaximize,
  FaSignOutAlt,
  FaCar,
  FaFlagCheckered,
} from "react-icons/fa";
import { GiCableStayedBridge } from "react-icons/gi";
import { MdMiscellaneousServices } from "react-icons/md";

class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new Metismenu(this.$el);
  }
  componentWillUnmount() {}
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

const SideBar = () => {
  const { iconHover, sidebarposition, headerposition, sidebarLayout } =
    useContext(ThemeContext);
  const role = getUserRole();
  // const { services, isLoading: servicesLoading } = useServicesQuery();
  useEffect(() => {
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");
    function toggleFunc() {
      return aaa.classList.toggle("menu-toggle");
    }
    btn.addEventListener("click", toggleFunc);

    //sidebar icon Heart blast
    // var handleheartBlast = document.querySelector('.heart');
    // function heartBlast() {
    // 	return handleheartBlast.classList.toggle("heart-blast");
    // }
    // handleheartBlast.addEventListener('click', heartBlast);
  }, []);
  //For scroll
  const [hideOnScroll, setHideOnScroll] = useState(true);
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll]
  );
  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];
  /// Active menu
  let deshBoard = [
      "dashboard",
      "dashboard-dark",
      "instructors",
      "activity",
      "profile",
      "task",
    ],
    InspectionAPP = [
      "inspectionDashboard",
      "course-details-1",
      "course-details-2",
    ],
    HotelScanner = [
      "hotels",
      "Hotels",
      "Physical-Rooms",
      "physical-rooms",
      "booking-cities",
      "website-content",
      "Resorts-Content",
      "reservations",
      "promotions",
      "hotelScanner-users",
    ],
    instructor = [
      "instructor-dashboard",
      "instructor-courses",
      "instructor-schedule",
      "instructor-students",
      "instructor-resources",
      "instructor-transactions",
    ],
    // Eticketing=[
    // 	"instructor-dashboard",
    // 	"instructor-courses",
    // 	"instructor-schedule",
    // 	"instructor-students",
    // 	"instructor-resources",
    // 	"instructor-transactions",
    // ],
    Eticketing = [
      "Service-Manager-City",
      "service-manager-resorts",
      "Service-Manager-Services",

      "Contents",
      "Service-Manager-boating-Dashboard",
    ],
    MainWebCMS = [
      // Main Sections
      "home",
      "profile",
      "leadership",
      "contact-us",
      "fleet-management-content",

      // Top Attractions
      "top-attractions",
      "top-attractions-by-destination",
      "top-attractions-by-city",

      // Travel & Events
      "events",
      "festivals",
      "news",
    ],
    app = [
      "app-profile",
      "post-details",
      "app-calender",
      "email-compose",
      "email-inbox",
      "email-read",
      "ecom-product-grid",
      "ecom-product-list",
      "ecom-product-order",
      "ecom-checkout",
      "ecom-invoice",
      "ecom-customers",
      "post-details",
      "ecom-product-detail",
    ],
    email = ["email-compose", "email-inbox", "email-read"],
    shop = [
      "ecom-product-grid",
      "ecom-product-list",
      "ecom-product-list",
      "ecom-product-order",
      "ecom-checkout",
      "ecom-invoice",
      "ecom-customers",
      "ecom-product-detail",
    ],
    charts = [
      "chart-rechart",
      "chart-flot",
      "chart-chartjs",
      "chart-chartist",
      "chart-sparkline",
      "chart-apexchart",
    ],
    bootstrap = [
      "ui-accordion",
      "ui-badge",
      "ui-alert",
      "ui-button",
      "ui-modal",
      "ui-button-group",
      "ui-list-group",
      "ui-card",
      "ui-carousel",
      "ui-dropdown",
      "ui-popover",
      "ui-progressbar",
      "ui-tab",
      "ui-typography",
      "ui-pagination",
      "ui-grid",
    ],
    plugins = [
      "uc-select2",
      "uc-nestable",
      "uc-sweetalert",
      "uc-toastr",
      "uc-noui-slider",
      "map-jqvmap",
      "uc-lightgallery",
    ],
    redux = ["redux-form", "redux-wizard", "todo"],
    widget = ["widget-basic"],
    forms = [
      "form-element",
      "form-wizard",
      "form-editor-summernote",
      "form-pickers",
      "form-validation-jquery",
    ],
    table = ["table-bootstrap-basic", "table-datatable-basic"],
    pages = [
      "page-register",
      "page-login",
      "page-lock-screen",
      //   "page-error-400",
      //   "page-error-403",
      "page-error-404",
      //   "page-error-500",
      //   "page-error-503",
    ],
    error = ["page-error-404"];

  const usersManagement = ["users"];

  return (
    <div
      className={`dlabnav ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? hideOnScroll > 120
            ? "fixed"
            : ""
          : ""
      }`}
    >
      <PerfectScrollbar className="dlabnav-scroll">
        <MM className="metismenu" id="menu">
          <Can I="view" a="DashboardSideMenu">
            <li className={`${deshBoard.includes(path) ? "mm-active" : ""}`}>
              <Link className="ai-icon" to="/dashboard">
                <FaTachometerAlt />
                <span className="nav-text">Dashboard</span>
              </Link>
            </li>
          </Can>
          <Can I="view" a="InspectionSideMenu">
            {["admin", "superadmin", "externalmanager"].includes(
              (role || "").toLowerCase().replace(/\s+/g, "")
            ) && (
              <li
                className={`${InspectionAPP.includes(path) ? "mm-active" : ""}`}
              >
                <Link className="has-arrow" to="/inspectionAPP">
                  <FaClipboardCheck />
                  <span className="nav-text">Inspection APP</span>
                </Link>
                <ul>
                  <li>
                    <Link
                      className={`${path === "Reports" ? "mm-active" : ""}`}
                      to="/Reports"
                    >
                      Inspection Reports
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`${path === "Tasks" ? "mm-active" : ""}`}
                      to="/Tasks"
                    >
                      Tasks
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`${
                        path === "inspection-users" ? "mm-active" : ""
                      }`}
                      to="/inspection-users"
                    >
                      Users
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`${
                        path === "activity-tracker" ? "mm-active" : ""
                      }`}
                      to="/activity-tracker"
                    >
                      Activity Tracker
                    </Link>
                  </li>
                </ul>
              </li>
            )}
          </Can>

          <Can I="view" a="ResortBookingSideMenu">
            {["admin", "superadmin", "hoteladmin", "reservationadmin", "externalmanager"].includes(
              (role || "").toLowerCase().replace(/\s+/g, "")
            ) && (
              <li
                className={`${HotelScanner.includes(path) ? "mm-active" : ""}`}
              >
                <Link className="has-arrow ai-icon" to="#">
                  <FaBuilding />
                  <span className="nav-text">Resort Bookings</span>
                </Link>
                <ul>
                  {["admin", "superadmin"].includes(
                    (role || "").toLowerCase().replace(/\s+/g, "")
                  ) && (
                    <>
                    <li>
                        <Link
                          className={`${
                            path === "Resorts-Dashboard" ? "mm-active" : ""
                          }`}
                          to="/Resorts-Dashboard"
                        >
                          Dashboard
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={`${
                            path === "website-content" ? "mm-active" : ""
                          }`}
                          to="/Website-Content"
                        >
                          Website Content
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={`${
                            path === "booking-cities" ? "mm-active" : ""
                          }`}
                          to="/Booking-Cities"
                        >
                          Cities
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={`${
                            path === "Resorts-Content" ? "mm-active" : ""
                          }`}
                          to="/Resorts-Content"
                        >
                          CMS
                        </Link>
                      </li>
                    </>
                  )}
                  {!["reservationadmin"].includes(
                    (role || "").toLowerCase().replace(/\s+/g, "")
                  ) && (
                    <>
                      <li>
                        <Link
                          className={`${path === "hotels" || path === "Hotels" ? "mm-active" : ""}`}
                          to="/Hotels"
                        >
                          Hotels
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={`${
                            path === "Physical-Rooms" || path === "physical-rooms"
                              ? "mm-active"
                              : ""
                          }`}
                          to="/Physical-Rooms"
                        >
                          Physical Rooms
                        </Link>
                      </li>
                    </>
                  )}
                  <li>
                    <Link
                      className={`${path === "services" ? "mm-active" : ""}`}
                      to="/services"
                    >
                      Services
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`${
                        path === "reservations" ? "mm-active" : ""
                      }`}
                      to="/Reservations"
                    >
                      Reservations
                    </Link>
                  </li>
                  {!["reservationadmin"].includes(
                    (role || "").toLowerCase().replace(/\s+/g, "")
                  ) && (
                    <li>
                      <Link
                        className={`${
                          path === "promotions" ? "mm-active" : ""
                        }`}
                        to="/Booking-Promotions"
                      >
                        Promotions
                      </Link>
                    </li>
                  )}
                  <li>
                    <Link
                      className={`${
                        path === "hotelScanner-users" ? "mm-active" : ""
                      }`}
                      to="/Booking-Users"
                    >
                      Users
                    </Link>
                  </li>
                </ul>
              </li>
            )}
          </Can>

          <Can I="view" a="FleetManagementSideMenu">
            <li>
              <Link className="has-arrow ai-icon" to="#">
                <FaCar />
                <span className="nav-text">Fleet Management</span>
              </Link>
              <ul>
                <li>
                  <Link to={`/fleet-management/dashboard`}>
                    Dashboard
                  </Link>
                </li>
                <li>
                  <Link to={`/fleet-management/drivers`}>
                    Drivers
                  </Link>
                </li>
                {/* <li>
                  <Link to={`/fleet-management/vehicle-categories`}>
                    Vehicle Categories
                  </Link>
                </li> */}
                <li>
                  <Link to={`/fleet-management/vehicles`}>
                    Vehicles
                  </Link>
                </li>
                <li>
                  <Link to={`/fleet-management/bookings`}>
                    Bookings
                  </Link>
                </li>
                <li>
                  <Link to={`/fleet-management/general-expenses`}>
                    General Expenses
                  </Link>
                </li>
                {/* <li>
                  <Link to={`/fleet-management/driver-expenses`}>
                    Driver Expenses
                  </Link>
                </li> */}
              </ul>
            </li>
          </Can>

          <Can I="view" a="JeepRallySideMenu">
            <li>
              <Link className="has-arrow ai-icon" to="#">
                <FaFlagCheckered />
                <span className="nav-text">Jeep Rally</span>
              </Link>
              <ul>
                <li>
                  <Link to={`/jeep-rally/rallies`}>Rallies</Link>
                </li>
                <li>
                  <Link to={`/jeep-rally/routes`}>Routes</Link>
                </li>
                <li>
                  <Link className="has-arrow" to="#">
                    Participants
                  </Link>
                  <ul>
                    <li>
                      <Link to={`/jeep-rally/participants/competitors`}>
                        Competitors
                      </Link>
                    </li>
                    <li>
                      <Link to={`/jeep-rally/participants/visitors`}>
                        Visitors
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to={`/jeep-rally/ranking`}>Ranking</Link>
                </li>
                <li>
                  <Link to={`/jeep-rally/categories`}>Categories</Link>
                </li>
                <li>
                  <Link to={`/jeep-rally/types`}>Types</Link>
                </li>
                <li>
                  <Link to={`/jeep-rally/content`}>Content</Link>
                </li>
              </ul>
            </li>
          </Can>

          {/* <Can I="view" a="TripPlannerSideMenu">
            <li>
              <Link className="has-arrow ai-icon" to="#">
                <FaWindowMaximize />
                <span className="nav-text">Trip Planner</span>
              </Link>
              <ul>
                <li>
                  <Link to={`/trip-planner/dashboard`}>
                    Dashboard
                  </Link>
                </li>
              </ul>
            </li>
          </Can> */}


          <Can I="view" a="EticketingSideMenu">
            <li>
              <Link className="has-arrow ai-icon" to="#">
                <FaTicketAlt />
                <span className="nav-text">General e-ticketing</span>
              </Link>
              <ul>
                {/* E-Ticketing Dashboard */}
                <li>
                  <Link to={`/E-Ticketing-Dashboard?service_id=7`}>
                    Dashboard
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/Service-Manager/general-e-ticketing/7/Reservations`}
                  >
                    Reservations
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/Service-Manager/general-e-ticketing/7/routes-prices`}
                  >
                    Manage Services
                  </Link>
                </li>
              </ul>
            </li>
          </Can>
          <Can I="view" a="ChairLiftAndCableCarSideMenu">
            <li>
              <Link className="has-arrow ai-icon" to="#">
                <GiCableStayedBridge />
                <span className="nav-text">Chairlift & Cable Car</span>
              </Link>
              <ul>
                {/* E-Ticketing Dashboard */}
                <li>
                  <Link to={`/Service-Manager/patriata-chairlift/1/Dashboard`}>
                    Dashboard
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/Service-Manager/patriata-chairlift/1/Reservations`}
                  >
                    Reservations
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/Service-Manager/patriata-chairlift/1/routes-prices`}
                  >
                    Service Category
                  </Link>
                </li>
                <Can I="view" a="CMS">
                  <li>
                    <Link to={`/Service-Manager/patriata-chairlift/1/Contents`}>
                      CMS
                    </Link>
                  </li>
                </Can>
              </ul>
            </li>
          </Can>
          <Can I="view" a="SightseeingSideMenu">
            <li>
              <Link className="has-arrow ai-icon" to="#">
                <FaBinoculars />
                <span className="nav-text">Sightseeing</span>
              </Link>
              <ul>
                {/* E-Ticketing Dashboard */}
                <li>
                  <Link to={`/Service-Manager/sightseeing/2/Dashboard`}>
                    Dashboard
                  </Link>
                </li>
                <li>
                  <Link to={`/Service-Manager/sightseeing/2/Reservations`}>
                    Reservations
                  </Link>
                </li>
                <li>
                  <Link to={`/Service-Manager/sightseeing/2/routes-prices`}>
                    Service Category
                  </Link>
                </li>
                <Can I="view" a="CMS">
                  <li>
                    <Link to={`/Service-Manager/sightseeing/2/Contents`}>
                      CMS
                    </Link>
                  </li>
                </Can>
              </ul>
            </li>
          </Can>
          <Can I="view" a="BoatingSideMenu">
            <li>
              <Link className="has-arrow ai-icon" to="#">
                <FaShip />
                <span className="nav-text">Boating</span>
              </Link>
              <ul>
                {/* E-Ticketing Dashboard */}
                <li>
                  <Link to={`/Service-Manager/boating/3/Dashboard`}>
                    Dashboard
                  </Link>
                </li>
                <li>
                  <Link to={`/Service-Manager/boating/3/Reservations`}>
                    Reservations
                  </Link>
                </li>
                <li>
                  <Link to={`/Service-Manager/boating/3/routes-prices`}>
                    Service Category
                  </Link>
                </li>
                <Can I="view" a="CMS">
                  <li>
                    <Link to={`/Service-Manager/boating/3/Contents`}>CMS</Link>
                  </li>
                </Can>
              </ul>
            </li>
          </Can>
          <Can I="view" a="SoftwheelTrainSideMenu">
            <li>
              <Link className="has-arrow ai-icon" to="#">
                <FaTrain />
                <span className="nav-text">Softwheel Train</span>
              </Link>
              <ul>
                {/* E-Ticketing Dashboard */}
                <li>
                  <Link to={`/Service-Manager/softwheel-train/6/Dashboard`}>
                    Dashboard
                  </Link>
                </li>
                <li>
                  <Link to={`/Service-Manager/softwheel-train/6/Reservations`}>
                    Reservations
                  </Link>
                </li>
                <li>
                  <Link to={`/Service-Manager/softwheel-train/6/routes-prices`}>
                    Service Category
                  </Link>
                </li>
                <Can I="view" a="CMS">
                  <li>
                    <Link to={`/Service-Manager/softwheel-train/6/Contents`}>
                      CMS
                    </Link>
                  </li>
                </Can>
              </ul>
            </li>
          </Can>
          <Can I="view" a="MainSiteSideMenu">
            {["admin", "superadmin", "hoteladmin", "reservationadmin"].includes(
              (role || "").toLowerCase().replace(/\s+/g, "")
            ) && (
              <li className={`${MainWebCMS.includes(path) ? "mm-active" : ""}`}>
                <Link className="has-arrow ai-icon" to="#">
                  <FaGlobe />
                  <span className="nav-text">Main Web CMS</span>
                </Link>
                <ul>
                  {["admin", "superadmin"].includes(
                    (role || "").toLowerCase().replace(/\s+/g, "")
                  ) && (
                    <>
                      <li>
                        <Link
                          className={`${
                            path === "main-pages" ? "mm-active" : ""
                          }`}
                          to="/WebCMS/main-pages"
                        >
                          Main Pages
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={`${
                            path === "fleet-management-content"
                              ? "mm-active"
                              : ""
                          }`}
                          to="/WebCMS/fleet-management-content"
                        >
                          Fleet Management Content
                        </Link>
                      </li>
                    </>
                  )}
                  {!["reservationadmin"].includes(
                    (role || "").toLowerCase().replace(/\s+/g, "")
                  ) && <></>}
                  <li></li>
                  <li
                    className={` ${
                      path.startsWith("top-attractions")
                        ? "mm-active mm-show"
                        : ""
                    }`}
                  >
                    <Link className="has-arrow" to="#">
                      Top Attractions
                    </Link>
                    <ul>
                      <li>
                        <Link
                          className={`${
                            path === "top-attractions-by-region"
                              ? "mm-active"
                              : ""
                          }`}
                          to="/WebCMS/by-region"
                        >
                          By Region
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={`${
                            path === "top-attractions-by-interest"
                              ? "mm-active"
                              : ""
                          }`}
                          to="/WebCMS/by-interest"
                        >
                          By Interest
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={`${
                            path === "top-attractions-by-site"
                              ? "mm-active"
                              : ""
                          }`}
                          to="/WebCMS/by-site"
                        >
                          Sites
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link
                      className={`${path === "plan-a-trip" ? "mm-active" : ""}`}
                      to="/WebCMS/plan-a-trip"
                    >
                      Plan a trip
                    </Link>
                  </li>
                  {!["reservationadmin"].includes(
                    (role || "").toLowerCase().replace(/\s+/g, "")
                  ) && (
                    <li>
                      <Link
                        className={`${path === "events" ? "mm-active" : ""}`}
                        to="/WebCMS/events"
                      >
                        Events
                      </Link>
                    </li>
                  )}
                  <li>
                    <Link
                      className={`${path === "festivals" ? "mm-active" : ""}`}
                      to="/WebCMS/festivals"
                    >
                      Festivals
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`${
                        path === "create-content" ? "mm-active" : ""
                      }`}
                      to="/WebCMS/create-content"
                    >
                      Content Page
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`${
                        path === "newsletter-subscribers" ? "mm-active" : ""
                      }`}
                      to="/WebCMS/newsletter-subscribers"
                    >
                      Newsletter Subscribers
                    </Link>
                  </li>
                </ul>
              </li>
            )}
          </Can>
          <Can I="view" a="ServiceManagerSideMenu">
            <li className={`${Eticketing.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#">
                <MdMiscellaneousServices />
                <span className="nav-text">Service Manager</span>
              </Link>
              <ul>
                <li>
                  <Link
                    className={`${
                      path === "Service-Manager-City" ? "mm-active" : ""
                    }`}
                    to="/Service-Manager-City"
                  >
                    Cities
                  </Link>
                </li>
                <li>
                  <Link
                    className={`${
                      path === "Service-Manager-Services" ? "mm-active" : ""
                    }`}
                    to="/Service-Manager-Services"
                  >
                    Services
                  </Link>
                </li>
                {/* <li>
                  <Link
                    className={`${
                      path === "Service-Manager-Bus" ? "mm-active" : ""
                    }`}
                    to="/Service-Manager-Bus"
                  >
                    Buses
                  </Link>
                </li> */}
              </ul>
            </li>
          </Can>

          <Can I="view" a="UsersManagement">
            <li
              className={`${usersManagement.includes(path) ? "mm-active" : ""}`}
            >
              <Link className="" to="/users">
                <FaUsers />
                <span className="nav-text">Users Management</span>
              </Link>
            </li>
          </Can>

          {/* Logout Option */}
          <li>
            <LogoutPage />
          </li>
        </MM>
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
